import {Component} from "@angular/core";
import {DBButtonModule, DBModalModule, DBModalService, DBPanelModule} from "@db/db-core";
import {getAppThemeName, getCookie} from "../../../core/functions/common.function";
import {TranslatePipe} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {saveAs} from 'file-saver';
import {CommonService} from "../../services/common.service";
import {CookieNoticeModal} from "../cookie-notice/cookie-notice.modal";

@Component({
  standalone: true,
  selector: 'privacy-modal',
  imports: [DBModalModule, TranslatePipe, DBButtonModule, DBPanelModule],
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss']
})
export class PrivacyModalComponent {
  private readonly modalService: DBModalService;
  private http: HttpClient;
  private appService: CommonService;


  constructor(modalService: DBModalService, http: HttpClient, appService: CommonService) {
    this.modalService = modalService;
    this.http = http;
    this.appService = appService
  }

  public onClose(): void {
    this.modalService.close().then(() => {
      if (getCookie("COOKIE_ACCEPTED") === '') {
        this.modalService.openWithComponent(CookieNoticeModal, {closeOnBackdropClickOrEscKey: false});
      }
    });
  }

  /**
   * pdf file name must be privacy-<language>.pdf in the proper brand name folder in pdfs.
   * **/
  onClickDownload() {
    try {
      this.http.get('/assets/pdfs/' + getAppThemeName() + '/privacy-' + this.appService._languageData.value.activeLang +'.pdf', {
        responseType: 'blob'
      }).subscribe(response => {
        saveAs(response, 'privacy.pdf');
      });

    } catch (error) {
      console.error('Error downloading file:', error);
    }
    this.onClose();
  }

  protected readonly getAppThemeName = getAppThemeName;
}
